export default __webpack_public_path__ + "static/media/searchIcon.432e27b7.svg";